import React from 'react';
import {
  BAKKIE_LOCAL_BAND,
  WORKED_EXAMPLE_KM,
  bakkieLocalFare,
  formatRand,
} from '../../../config/rateCard';

/**
 * The worked example used to sit at 25 km, which is at or past the edge of the
 * R10/km band: the engine charges R592 for a 25.4 km bakkie, not the R474 that
 * rate implies. The estimate widget directly above this band shows the live
 * figure, so the page was displaying two prices for one trip. The example now
 * sits at 15 km, inside the range verified against production.
 */
const PriceBandSection: React.FC = () => {
  const figures = [
    { figure: formatRand(BAKKIE_LOCAL_BAND.base), label: 'Bakkie base fee' },
    { figure: `${formatRand(BAKKIE_LOCAL_BAND.perKm)} / km`, label: 'Bakkie, short local trips' },
    {
      figure: `~${formatRand(bakkieLocalFare(WORKED_EXAMPLE_KM))}`,
      label: `${WORKED_EXAMPLE_KM} km bakkie estimate`,
    },
  ];

  return (
    <section className="sw-price-band sw-on-dark" aria-labelledby="sw-price-heading">
      <div className="container">
        <div className="sw-price-band-head">
          <span className="sw-eyebrow">Bakkie local estimate</span>
          <h2 id="sw-price-heading">For a short local bakkie trip.</h2>
          <p>
            These sample figures are for Bakkie estimates only. Larger vehicles and longer
            routes use different distance bands in the pricing engine.
          </p>
        </div>
        <div className="sw-price-grid">
          {figures.map((item) => (
            <div key={item.label}>
              <span className="sw-price-figure">{item.figure}</span>
              <span className="sw-price-label">{item.label}</span>
            </div>
          ))}
        </div>
        <p className="sw-price-note">
          The app shows your route estimate before you confirm. If the load is larger,
          heavier, difficult to access, or needs multiple trips, your driver may propose a
          revised fare for approval.
        </p>
      </div>
    </section>
  );
};

export default PriceBandSection;
